import http from '../../../services/api'
import type { APIResponse, Filters, APIPaginatedResponse, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'
import { ITEM_GROUP } from '../../../constants/ItemGroup'
import type { ServiceCategory } from '../types'

const apiPath = import.meta.env.VITE_API_PATH

const SERVICE_ITEM_GROUP_ID = ITEM_GROUP.find((g) => g.name === 'Service')?.value

function resolveServiceCategoryUuid(input: Pick<ServiceCategory, 'uuid'>): string {
  const uuid = input.uuid?.trim()
  if (!uuid) {
    throw new Error('Service category uuid is required')
  }
  return uuid
}

async function getServiceCategories(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getRequestParamString(filters, pagination)
  const itemGroupParam =
    SERVICE_ITEM_GROUP_ID != null ? `${paramString ? '&' : '?'}item_group_id=${SERVICE_ITEM_GROUP_ID}` : ''
  return await http.get<APIPaginatedResponse<ServiceCategory>>(
    `${apiPath}items/item-categories${paramString}${itemGroupParam}`,
  )
}

async function deleteServiceCategory(serviceCategoryUuid: string) {
  return await http.delete<APIResponse<boolean>>(
    `${apiPath}items/item-categories/${resolveServiceCategoryUuid({ uuid: serviceCategoryUuid })}`,
  )
}

async function createServiceCategory(input: ServiceCategory) {
  const payLoad = {
    name: input.name,
    item_group_id: SERVICE_ITEM_GROUP_ID,
    expires: false,
    loyalty_applicable: input.loyalty_applicable,
    description: input.description,
  }

  return await http.post<APIResponse<ServiceCategory>>(`${apiPath}items/item-categories`, payLoad)
}

async function updateServiceCategory(input: ServiceCategory) {
  const payLoad = {
    name: input.name,
    item_group_id: SERVICE_ITEM_GROUP_ID,
    expires: input.expires,
    loyalty_applicable: input.loyalty_applicable,
    description: input.description,
  }

  return await http.patch<APIResponse<ServiceCategory>>(
    `${apiPath}items/item-categories/${resolveServiceCategoryUuid(input)}`,
    payLoad,
  )
}

const serviceCategoryService = {
  getServiceCategories,
  deleteServiceCategory,
  createServiceCategory,
  updateServiceCategory,
}

export default serviceCategoryService
